import { peopleRef } from "@/vue-service-database";
import { updatePersonsGSuiteStatus } from "@/vue-service-api";
import { updatePersonSkillsRating } from "@/vue-service-skills";
import store from "@/store/";

function addNewPerson(newEmail, newFirstName, newLastName, skills) {
	const newPerson = {
		email: newEmail,
		fName: newFirstName,
		lName: newLastName
	};

	// Update Firebase with newPerson
	const newPersonRef = peopleRef.push();
	console.log("newPushKey", newPersonRef.key);
	newPersonRef.set(newPerson);
	// Update Store with newPerson
	let person;
	peopleRef
		.child(newPersonRef.key)
		.once("value")
		.then(snapshot => {
			person = snapshot.val();
			store.dispatch("SET_SELECTED_PERSON_KEY", newPersonRef.key);
			store.dispatch("SET_PERSON", person);
		});
	
	// Update skills of new person
	updatePersonSkillsRating(newPersonRef.key, skills);
	
}
function resetPersonForm() {
	const selectedPersonKey = this.$store.getters.selectedPersonKey;
	peopleRef
		.child(selectedPersonKey)
		.once("value")
		.then(snapshot => {
			this.$store.dispatch("SET_PERSON", snapshot.val());
		});
}
function savePersonFromForm() {
	const selectedPersonKey = this.$store.getters.selectedPersonKey;
	let person = this.$store.getters.person;
	// This process removes keys if they are not require, e.g., undefined
	Object.keys(person).forEach(
		selectedPersonKey => person[selectedPersonKey] == null && delete person[selectedPersonKey]
	);
	return peopleRef
		.child(selectedPersonKey)
		.update(person)
		.then(() => updatePersonsGSuiteStatus());
}
export {
	resetPersonForm,
	savePersonFromForm,
	addNewPerson,
};


// WEBPACK FOOTER //
// ./src/vue-service-form-person.js